export interface ReservationFeatureReadinessInput {
  arrivalOpenTableReady: boolean
  employeeCommissionApiReady: boolean
}

/**
 * 预订增量能力的统一门禁。
 *
 * 两项能力都依赖尚未纳入稳定契约的后端语义，必须由环境显式开启；
 * 未配置、拼写错误或仅处于 DEV 环境时一律 fail-closed。
 */
export function resolveReservationFeatureReadiness(
  input: ReservationFeatureReadinessInput,
): ReservationFeatureReadinessInput {
  return {
    arrivalOpenTableReady: input.arrivalOpenTableReady,
    employeeCommissionApiReady: input.employeeCommissionApiReady,
  }
}

export const RESERVATION_FEATURE_READINESS = resolveReservationFeatureReadiness({
  arrivalOpenTableReady: import.meta.env.VITE_RESERVATION_ARRIVAL_OPEN_TABLE_READY === "true",
  employeeCommissionApiReady: import.meta.env.VITE_RESERVATION_EMPLOYEE_COMMISSION_API_READY === "true",
})
